import { Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ButtonPropsType } from "../../interface/button";


export const ButtonContainedLight = ({
  sx,
  children,
  onclick,
}: ButtonPropsType) => {
  const theme = useTheme();
  return (
    <Button
      sx={{
        padding: "10px 30px",
        borderRadius: "40px",
        minWidth: "80px",
        height: "2.5rem",
        fontFamily: "DM Sans",
        fontWeight: 400,
        fontSixe: "14px",
        color: theme.palette.primary.main,
        background: theme.palette.lightBlue.main,
        border: `1px solid  ${theme.palette.primary.main}`,
        ...sx,
      }}
      onClick={onclick}
    >
      {children}
    </Button>
  );
};

export const ButtonText = ({ sx, children, onclick }: ButtonPropsType) => {
  const theme = useTheme();
  return (
    <Button
      variant="text"
      sx={{
        minWidth: "80px",
        height: "2.5rem",
        fontFamily: "DM Sans",
        fontWeight: 700,
        fontSixe: "14px",
        color: theme.palette.primary.main,
        
        ...sx,
      }}
      onClick={onclick}
    >
      {children}
    </Button>
  );
};
